<template>
  <div class="mb-10">
    <EducationHierarchySelect
      @setParameters="parameters = $event"
    />
    <v-btn
      :disabled="disabledBtn"
      depressed
      class="float-right"
      @click="setParameters()"
    >
      <v-icon left>
        mdi-magnify
      </v-icon>
      Aplicar filtros
    </v-btn>
  </div>
</template>

<script>
import EducationHierarchySelect from '@/components/contents/EducationHierarchySelect.vue'

export default {
  components: {
    EducationHierarchySelect
  },

  data: () => ({
    parameters: {}
  }),
  watch: {
  },
  computed: {
    disabledBtn () {
      return Object.keys(this.parameters).length === 0
    }
  },

  async created () {
  },

  methods: {

    setParameters () {
      const parameters = this.buildQuery(this.parameters)
      this.$emit('setParameters', parameters)
    },

    buildQuery (newParameters) {
      return Object.entries(newParameters)
        .filter(([_, value]) => value !== null)
        .map(
          ([key, value]) =>
            `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join('')
    }
  }
}
</script>
